import { createContext } from "react";
import type { DrawerContextProps } from "./types";

export const DrawerContext = createContext<DrawerContextProps>({
  onClose: () => {},
  closeLabel: undefined,
  headerId: undefined,
});
